import { render, staticRenderFns } from "./assignReasonDialog.vue?vue&type=template&id=1b48452e&scoped=true"
import script from "./assignReasonDialog.vue?vue&type=script&lang=js"
export * from "./assignReasonDialog.vue?vue&type=script&lang=js"
import style0 from "./assignReasonDialog.vue?vue&type=style&index=0&id=1b48452e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b48452e",
  null
  
)

export default component.exports